
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.368 14.853H.648c-.354 0-.64.28-.64.626v.705c0 .086.072.156.16.156h15.68c.088 0 .16-.07.16-.156v-.705a.633.633 0 00-.64-.626zM2.922 13.209a.81.81 0 00.12-.01l3.364-.578a.197.197 0 00.106-.055L14.99 4.27a.196.196 0 00.058-.138.192.192 0 00-.058-.138L11.666.738a.2.2 0 00-.142-.057.2.2 0 00-.142.057L2.904 9.035a.197.197 0 00-.056.104l-.59 3.293a.642.642 0 00.188.583.685.685 0 00.476.194z"}})])
          )
        }
      }
    